export default "__VITE_ASSET__1969b5f6__"